import * as React from 'react';
import AntInput from 'antd/lib/input';
import classNames from 'classnames';
import { TextAreaProps } from 'antd/lib/input/TextArea';
import { ThemeContext } from 'app-themes';

import styles from './TextArea.module.scss';

export class TextArea extends React.Component<
	TextAreaProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>
> {
	static contextType = ThemeContext;
	render() {
		const theme = this.context;
		const { className, ...restProps } = this.props;
		return <AntInput.TextArea 
			className={classNames(styles.textArea, className, {
				[styles[`textArea-${theme}`]]: theme !== '',
			})}		
			{...restProps} 
		/>;
	}
}

export default TextArea;
